/**
 * Amplitude tracking utility for sofatutor frontend applications
 *
 * Uses Browser SDK 2 exposed as `window.SofatutorAmplitudeBrowser` from the
 * Rails `amplitude_browser_sdk` pack (initialized by amplitude_tracking.coffee).
 */
function hasFunctionalityConsent() {
    const consentFn = window.Sofatutor?.consentGivenForCategory;
    if (typeof consentFn !== 'function') {
        return false;
    }
    try {
        return consentFn.call(window.Sofatutor, 'functionality') === true;
    }
    catch {
        return false;
    }
}
function ensureAmplitudeInitialized() {
    if (window.__sofatutorAmplitudeSdkInitialized === true)
        return;
    try {
        window.Sofatutor?.tracking?.amplitude?.initSdk?.();
    }
    catch {
        // swallow — tracking must never break the app
    }
}
let defaultProperties = {};
export const setDefaultAmplitudeProperties = (properties) => {
    defaultProperties = { ...defaultProperties, ...properties };
};
export const getDefaultAmplitudeProperties = () => {
    return { ...defaultProperties };
};
export const resetDefaultAmplitudeProperties = () => {
    defaultProperties = {};
};
const hasValidEventName = (eventName) => {
    return typeof eventName === 'string' && eventName.trim().length > 0;
};
export const amplitudeTracking = (eventName, properties) => {
    try {
        if (!hasValidEventName(eventName)) {
            return;
        }
        const mergedProperties = { ...defaultProperties, ...properties };
        const hasConsent = hasFunctionalityConsent();
        if (hasConsent) {
            ensureAmplitudeInitialized();
            const amp = window.SofatutorAmplitudeBrowser;
            if (amp?.track && window.__sofatutorAmplitudeSdkInitialized === true) {
                // iOS apps with the async session channel: share amplitude_tracking.coffee's
                // queue, so these events get the live session and keep their order.
                const tracker = window.Sofatutor?.tracking?.amplitude;
                if (tracker?.iosSessionChannel?.() && tracker.trackOnIos) {
                    tracker.trackOnIos(amp, eventName, mergedProperties);
                    return;
                }
                const eventOptions = window.Sofatutor?.tracking?.amplitude?.mobileIntegrateBeforeTrack?.(amp, eventName);
                if (eventOptions) {
                    amp.track(eventName, mergedProperties, eventOptions);
                }
                else {
                    amp.track(eventName, mergedProperties);
                }
                window.Sofatutor?.tracking?.amplitude?.mobileIntegrateAfterTrack?.(eventName);
                return;
            }
            window.queueSofatutorAmplitudeEvent?.({
                event: eventName,
                eventProperties: mergedProperties,
            });
            if (process.env.NODE_ENV === 'development') {
                console.log('[Amplitude Debug]', eventName, properties);
            }
            return;
        }
        if (window.__sofatutorAmplitudeSdkInitialized !== true) {
            window.queueSofatutorAmplitudeEvent?.({
                event: eventName,
                eventProperties: mergedProperties,
            });
        }
        if (process.env.NODE_ENV === 'development') {
            console.log('[Amplitude Debug]', eventName, properties);
        }
    }
    catch (error) {
        if (process.env.NODE_ENV === 'development') {
            console.warn('[Amplitude Error]', error);
        }
    }
};
export default amplitudeTracking;
